module.exports = __webpack_public_path__ + "static/media/3.5950c0a7.jpg";